const styles = (theme) => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  searchRow: {
    display: "flex",
    alignItems: "center",
  },
  trailerDetailsLabel: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    textAlign: "left",
    color: theme.dispatchPanelHeaderColor,
    letterSpacing: "1.5px",
    marginTop: 12,
    marginBottom: 8,
  },
  dollyInputRow: {
    display: "flex",
    alignItems: "center",
    marginTop: 4,
  },
  selectRootHook: {
    width: "100%",
  },
});

export default styles;
